import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import {
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import Svg, { Circle, Path } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux";

import BottomSheetModal from "../BottomSheetModal";
import Buttons from "components/Buttons";
import Carousel from "react-native-reanimated-carousel";
import { Colors } from "colors";
import ComingSoonCop from "components/ComingSoonCop";
import { Images } from "assets";
import Pagination from "src/components/Pagination";
import VText from "../VText";
import { useGlobalSearchParams } from "expo-router";
import { useRouter } from "expo-router";

export default React.forwardRef((props, ref) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);

  const { height, width } = useWindowDimensions();
  const router = useRouter();
  const local = useGlobalSearchParams();
  const gender = local?.gender || "female";
  const _bottomSheetRef = useRef();
  const carouselRef = useRef(null);

  const maxIndex = props?.productsData?.length;

  React.useImperativeHandle(ref, () => ({ show }), []);

  useEffect(() => {
    let activeIndex1 = activeIndex;
    let leftItems = maxIndex - activeIndex1 - 5;
    leftItems = leftItems < 0 ? 0 : leftItems;
    if (leftItems < 5) {
      //   carouselRef.current?.next({ count: leftItems });
    } else {
    }
    if (isDisabled) {
      setTimeout(() => {
        setIsDisabled(false);
      }, 650);
    }
  }, [activeIndex, isDisabled]);

  const show = () => {
    _bottomSheetRef?.current?.show();
  };

  const redirectToProduct = (item) => {
    router.push(
      `${gender == "men" ? "/men" : ""}/product/${item?.id}/${
        item?.brandName
      }/${item?.productName}`?.replaceAll(" ", "-")
    );
  };

  const handlePrev = () => {
    setIsDisabled(true);
    let activeIndex1 = activeIndex;
    let itemsToGoBack = activeIndex1 - 5;
    itemsToGoBack = itemsToGoBack < 0 ? activeIndex1 : 5;
    carouselRef.current?.prev({ count: itemsToGoBack });
  };

  const handleNext = () => {
    setIsDisabled(true);
    let activeIndex1 = activeIndex;
    let leftItems = maxIndex - activeIndex1 - 5;
    leftItems = leftItems < 0 ? 0 : leftItems;
    if (leftItems < 5) {
      carouselRef.current?.next({ count: leftItems });
    } else {
      carouselRef.current?.next({ count: 5 });
    }
  };

  return (
    <BottomSheetModal
      MAX_HEIGHT_PERC={1}
      START_PERC={1}
      ref={_bottomSheetRef}
      hideLine
      containerStyle={{
        backgroundColor: "transparent",
        zIndex: 100,
      }}
    >
      <TouchableOpacity
        style={{
          backgroundColor: "transparent",
          width,
          height,
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          zIndex: 100,
          cursor: "auto",
        }}
        activeOpacity={1}
        onPress={() => _bottomSheetRef?.current?.hide()}
      >
        <TouchableOpacity
          style={{
            width: wp(1100),
            height: hp(620),
            height: "auto",
            backgroundColor: "#fff",
            cursor: "auto",
            // paddingHorizontal:hp(10)
          }}
          activeOpacity={1}
        >
          <TouchableOpacity
            onPress={() => _bottomSheetRef?.current?.hide()}
            activeOpacity={0.8}
            style={{
              position: "absolute",
              right: 20,
              top: 20,
              zIndex: 100,
              // backgroundColor:"red"
            }}
          >
            <Svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
              <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                fill="#212427"
              />
            </Svg>
          </TouchableOpacity>
          <View
            style={{
              width: wp(1100),
              height: hp(570),
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <VText
              style={{
                fontSize: fp(32),
                fontFamily: "LibreBodoni",
                fontWeight: "500",
                color: "black",
                marginBottom: spV(20),
              }}
            >
              Shop Outfit Products{" "}
            </VText>
            <View>
              {activeIndex > 0 && (
                <TouchableOpacity
                  disabled={isDisabled}
                  style={{
                    position: "absolute",
                    left: -40,
                    top: 150,
                    display: activeIndex > 0 ? "flex" : "none",
                    zIndex: 1000,
                  }}
                  onPress={handlePrev}
                >
                  <Image
                    accessibilityLabel="Left Arrow"
                    source={Images.leftArrow}
                    style={{ width: wp(20), height: hp(20) }}
                  />
                </TouchableOpacity>
              )}

              <Carousel
                ref={carouselRef}
                loop={false}
                width={wp(250)}
                height={hp(460)}
                pagingEnabled
                style={{
                  width: wp(240 * 4),
                  pointerEvents: "auto",
                  cursor: "pointer",
                }}
                autoPlay={false}
                autoPlayInterval={2000}
                userInteractions={true}
                data={props?.productsData}
                renderItem={({ item, index }) => (
                  <View style={{ width: wp(240), height: hp(470) }}>
                    <TouchableOpacity onPress={() => redirectToProduct(item)}>
                      <Image
                        accessibilityLabel={`${item.brandName} ${item.productName} Image`}
                        source={item.imageUrls[0]}
                        style={{ width: wp(240), height: hp(320) }}
                        resizeMode="contain"
                      />

                      <View
                        style={{
                          marginVertical: spV(10),
                          width: wp(240),
                          paddingHorizontal: hp(8),
                        }}
                      >
                        <VText
                          style={{
                            fontSize: fp(16),
                            fontWeight: "700",
                            color: "#000000",
                            marginBottom: spV(8),
                          }}
                        >
                          {item.brandName}{" "}
                        </VText>
                        <VText
                          style={{
                            fontSize: fp(16),
                            fontWeight: "350",
                            color: "#000000",
                            marginBottom: spV(8),
                            minHeight: hp(45),
                          }}
                        >
                          {item.productName.length > 50
                            ? item.productName.substring(0, 50) + "..."
                            : item.productName}{" "}
                        </VText>
                        <VText
                          style={{
                            marginBottom: spV(8),
                            fontSize: fp(16),
                            fontWeight: "400",
                            color: "#000000",
                            opacity: item.salePercentage ? 1 : 0,
                          }}
                        >
                          $ {item.originalProductPrice}
                          <VText
                            style={{
                              fontSize: fp(14),
                              fontWeight: "300",
                              color: "#000000",
                            }}
                          >
                            {item.salePercentage} % off{" "}
                          </VText>
                        </VText>
                        <VText
                          style={{
                            fontSize: fp(15),
                            fontWeight: "400",
                            color:
                              item.salePercentage == 0 ? "#000000" : "#CE1A1A",
                          }}
                        >
                          $ {item.productPrice}
                        </VText>
                      </View>
                    </TouchableOpacity>
                  </View>
                )}
                onSnapToItem={setActiveIndex}
              />
              {activeIndex + 5 < maxIndex && (
                <TouchableOpacity
                  disabled={isDisabled}
                  style={{
                    position: "absolute",
                    right: -40,
                    top: 150,
                    zIndex: 1000,
                  }}
                  onPress={handleNext}
                >
                  <Image
                    accessibilityLabel="Right Arrow"
                    source={Images.rightArrow}
                    style={{ width: wp(20), height: hp(20) }}
                  />
                </TouchableOpacity>
              )}
            </View>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </BottomSheetModal>
  );
});

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    borderRadius: 8,
    width: wp(309),
  },
  image: {
    width: wp(309),
    height: hp(199),
  },
});
